module.exports = {"TXTWCL_Place_Bet":{"id":"TXTWCL_Place_Bet","defaultMessage":"Place Bet","track":"Place Bet"}}